import { Card, Col, Flex, Row, Typography } from "antd";
import styled from "styled-components";

import { Palette } from "../../../../core/styles/palette";

export const DashboardContainer = styled.div`
    background-color: ${Palette.DisabledBackground};
    padding: 24px;
`;

export const DashboardRow = styled(Row)`
    margin-bottom: 16px;
`;

export const DashboardHeroStatsRow = styled(Row)`
    height: 100%;
`;

export const DashboardFlexBoxCol = styled(Col)`
    display: flex;
`;

export const DashboardFlexCardWrapper = styled.div`
    flex: 1;

    > * {
        flex: 1;
    }
`;

// ─── Welcome Card ─────────────────────────────────────────────────────────────

export const WelcomeCardContainer = styled(Card)`
    background-color: ${Palette.White};
    height: 100%;
`;

export const WelcomeCardFlexStyle = styled(Flex)`
    height: 100%;
`;

export const WelcomeCardTitle = styled(Typography.Title)`
    && {
        margin: 0;
    }
`;

// ─── Activity Cards ─────────────────────────────────────────────────────────────

export const DashboardCardContainer = styled(Card)`
    background-color: ${Palette.White};
    height: 100%;
`;
